module.exports = __webpack_public_path__ + "vn.svg?010b0c4c6dc4bdb48895ab271d4544c4";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/vn.svg
// module id = 1690
// module chunks = 0